import { useDataValue, useDataChange, useDataSubmit } from 'Simple/Data.js'

export default function useDataOnChange(props) {
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let hipaa = useDataValue({
    context: 'global',
    viewPath: props.viewPath,
    path: 'user.preferences.hipaa',
  })

  let submit = useDataSubmit({
    context: 'global',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      next.selected.topbar_appointment_templates =
        value.selected_appointment_templates
      next.selected.slot_interval = value.slot_interval
      next.selected.slot_interval_settings = value.slot_interval
      next.selected.full_day_default = value.full_day_default
      next.selected.patient_default = value.patient_default
    })

    if (hipaa !== value.hipaa) {
      submit({
        type: 'session/updateHipaa',
        hipaa: value.hipaa,
      })
    }
  }
}
